'use client';

import { c as _c } from "react/compiler-runtime";
import ButtonTooltip from '@components/button-tooltip/ButtonTooltip';
import ButtonsShare from '@components/buttons-share/ButtonsShare';
import api from '@lib/api';
import { copiedLinkFlatSelector } from '@lib/store/slices/ComponentsSlice';
import { useViewport } from '@lib/tools/hooks/useViewport';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import style from './CircleButton.module.scss';
const CircleButton = t0 => {
  const $ = _c(39);
  const {
    children,
    handleClick,
    isActive,
    flatid,
    genPlan,
    tooltipText,
    share,
    someStyles,
    testId,
    heart
  } = t0;
  const t1 = !isActive;
  const t2 = genPlan && !isActive;
  let t3;
  if ($[0] !== isActive || $[1] !== t1 || $[2] !== t2) {
    t3 = classNames({
      [style.circle__btn]: t1,
      [style.circle__btn__white]: t2,
      [style.circle__btn__active]: isActive
    });
    $[0] = isActive;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const btnClass = t3;
  const [showTooltip, setShowTooltip] = useState(false);
  const copiedLinkFlat = useSelector(copiedLinkFlatSelector);
  let t4;
  if ($[4] !== heart || $[5] !== isActive || $[6] !== testId) {
    t4 = () => {
      if (testId && isActive && heart) {
        return testId[0];
      }
      if (testId && !isActive && heart) {
        return testId[1];
      }
      return testId;
    };
    $[4] = heart;
    $[5] = isActive;
    $[6] = testId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const getTestId = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setShowTooltip(true);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleMouseOver = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setShowTooltip(false);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleMouseOut = t6;
  const shareRef = useRef(false);
  let t7;
  let t8;
  if ($[10] !== isActive) {
    t7 = () => {
      shareRef.current = isActive;
      setShowTooltip(Boolean(shareRef.current));
    };
    t8 = [isActive, shareRef];
    $[10] = isActive;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t9;
  if ($[13] !== children || $[14] !== flatid || $[15] !== genPlan || $[16] !== handleClick || $[17] !== isActive || $[18] !== share || $[19] !== showTooltip || $[20] !== someStyles || $[21] !== tooltipText) {
    t9 = flatid && <PdfLink isActive={isActive} genPlan={genPlan} someStyles={someStyles} handleMouseOver={handleMouseOver} handleMouseOut={handleMouseOut} handleClick={handleClick} flatid={flatid} children={children} tooltipText={tooltipText} showTooltip={showTooltip} share={share} />;
    $[13] = children;
    $[14] = flatid;
    $[15] = genPlan;
    $[16] = handleClick;
    $[17] = isActive;
    $[18] = share;
    $[19] = showTooltip;
    $[20] = someStyles;
    $[21] = tooltipText;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== btnClass || $[24] !== children || $[25] !== copiedLinkFlat || $[26] !== flatid || $[27] !== genPlan || $[28] !== getTestId || $[29] !== handleClick || $[30] !== isActive || $[31] !== share || $[32] !== showTooltip || $[33] !== someStyles || $[34] !== tooltipText) {
    t10 = !flatid && <BaseButton handleClick={handleClick} handleMouseOver={handleMouseOver} handleMouseOut={handleMouseOut} genPlan={genPlan} isActive={isActive} btnClass={btnClass} someStyles={someStyles} getTestId={getTestId} children={children} tooltipText={tooltipText} showTooltip={showTooltip} share={share} copiedLinkFlat={copiedLinkFlat} />;
    $[23] = btnClass;
    $[24] = children;
    $[25] = copiedLinkFlat;
    $[26] = flatid;
    $[27] = genPlan;
    $[28] = getTestId;
    $[29] = handleClick;
    $[30] = isActive;
    $[31] = share;
    $[32] = showTooltip;
    $[33] = someStyles;
    $[34] = tooltipText;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t10 || $[37] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[36] = t10;
    $[37] = t9;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  return t11;
};
const PdfLink = t0 => {
  const $ = _c(15);
  const {
    isActive,
    genPlan,
    someStyles,
    handleMouseOver,
    handleMouseOut,
    handleClick,
    flatid,
    children,
    tooltipText,
    showTooltip,
    share
  } = t0;
  const btnLink = classNames({
    [style.circle__btn__link]: !isActive,
    [style.circle__btn__link__white]: genPlan && !isActive,
    [style.circle__btn__active]: isActive
  });
  const {
    isDesktop
  } = useViewport();
  const t1 = classNames(btnLink, {
    [someStyles]: genPlan
  });
  let t2;
  if ($[0] !== handleClick) {
    t2 = () => handleClick ? handleClick() : undefined;
    $[0] = handleClick;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${api.urlPdf}/flats.pdf?ids=${flatid}`;
  let t4;
  if ($[2] !== isDesktop || $[3] !== share || $[4] !== showTooltip || $[5] !== tooltipText) {
    t4 = tooltipText && showTooltip && isDesktop && !share && <ButtonTooltip text={tooltipText} className={style.btnTooltip} />;
    $[2] = isDesktop;
    $[3] = share;
    $[4] = showTooltip;
    $[5] = tooltipText;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== handleMouseOut || $[9] !== handleMouseOver || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <><a className={t1} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onFocus={_temp} onBlur={_temp2} onClick={t2} href={t3} target="_blank" rel="noreferrer" data-testid="viewPdf">{children}{t4}</a></>;
    $[7] = children;
    $[8] = handleMouseOut;
    $[9] = handleMouseOver;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
const BaseButton = t0 => {
  const $ = _c(27);
  const {
    handleClick,
    handleMouseOver,
    handleMouseOut,
    genPlan,
    isActive,
    btnClass,
    someStyles,
    getTestId,
    children,
    tooltipText,
    showTooltip,
    share,
    copiedLinkFlat
  } = t0;
  let t1;
  if ($[0] !== handleClick) {
    t1 = () => {
      if (typeof handleClick === "function") {
        handleClick();
      }
    };
    $[0] = handleClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${btnClass} ${genPlan && !isActive ? someStyles : ""}`;
  let t3;
  if ($[2] !== getTestId) {
    t3 = getTestId();
    $[2] = getTestId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isActive || $[5] !== share || $[6] !== showTooltip || $[7] !== tooltipText) {
    t4 = tooltipText && showTooltip && !share && !isActive && <ButtonTooltip text={tooltipText} className={style.btnTooltip} />;
    $[4] = isActive;
    $[5] = share;
    $[6] = showTooltip;
    $[7] = tooltipText;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== copiedLinkFlat || $[10] !== share || $[11] !== showTooltip) {
    t5 = showTooltip && share && !copiedLinkFlat && <ButtonTooltip className={classNames(style.btnTooltip, style.btnTooltip__back)} children={<ButtonsShare />} />;
    $[9] = copiedLinkFlat;
    $[10] = share;
    $[11] = showTooltip;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== copiedLinkFlat || $[14] !== share || $[15] !== showTooltip) {
    t6 = showTooltip && share && copiedLinkFlat && <ButtonTooltip className={classNames(style.btnTooltip, style.btnTooltip__copied)} textSvg={"\n                    <p>\n                            <svg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'>\n                                <path\n                                    d='M6.75163 7.26307C7.20552 7.71806 7.20507 8.45472 6.75063 8.90915C6.29542 9.36437 5.55724 9.36392 5.10257 8.90816L0.352925 4.14707L2 2.5L6.75163 7.26307Z'\n                                    fill='white'\n                                />\n                                <path d='M12.3529 0.019043L14 1.66612L5.93061 9.73549L4.28354 8.08841L12.3529 0.019043Z' fill='white' />\n                            </svg>\n                         <p>\u0421\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430</p></p>\n                    "} />;
    $[13] = copiedLinkFlat;
    $[14] = share;
    $[15] = showTooltip;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== children || $[18] !== handleMouseOut || $[19] !== handleMouseOver || $[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
    t7 = <button onClick={t1} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onFocus={_temp3} onBlur={_temp4} className={t2} data-testid={t3}>{children}{t4}{t5}{t6}</button>;
    $[17] = children;
    $[18] = handleMouseOut;
    $[19] = handleMouseOver;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};
export default CircleButton;
function _temp() {
  return null;
}
function _temp2() {
  return null;
}
function _temp3() {
  return null;
}
function _temp4() {
  return null;
}